import { TaskFullSla, SlaCurrentStatusReadOnly } from '@askporter/client-grieg-lyric';

export type SlaStatusType = 'DueStatus' | 'RespondStatus' | 'ResolveStatus';
export type SlaFilter = 'RESOLUTION' | 'RESPONSE' | undefined;

type GetSlaStatus = ({ sla, slaFilter }: { sla: TaskFullSla; slaFilter: SlaFilter }) => {
  slaStatusType: SlaStatusType;
  currentStatus: SlaCurrentStatusReadOnly;
} | null;

export const getSlaStatus: GetSlaStatus = ({ sla, slaFilter }) => {
  const { type = null, response = null, resolution = null, due = null } = sla;

  if (slaFilter === 'RESOLUTION' && resolution?.status) {
    return { slaStatusType: 'ResolveStatus', currentStatus: resolution.status };
  } else if (slaFilter === 'RESPONSE' && response?.status) {
    return { slaStatusType: 'RespondStatus', currentStatus: response.status };
  }

  if (type === 'USER' && due?.status) {
    return {
      slaStatusType: 'DueStatus',
      currentStatus: due.status,
    };
  } else if (resolution?.status && response?.status && ['RUNNING', 'OVERDUE', 'PAUSED'].includes(response.status)) {
    return { slaStatusType: 'RespondStatus', currentStatus: response.status };
  } else if (
    resolution?.status &&
    response?.status &&
    ['COMPLETED_LATE', 'COMPLETED_ON_TIME'].includes(response.status)
  ) {
    return { slaStatusType: 'ResolveStatus', currentStatus: resolution.status };
  }
  return null;
};
